import React from 'react';
import { ConnectionStatusBanner } from './ConnectionStatusBanner';
import { useNetwork } from '../../contexts/NetworkContext';

export const OfflineBanner: React.FC = () => {
  return <ConnectionStatusBanner />;
};

export const useOfflineGuard = () => {
  const { isOffline, pendingOperationsCount } = useNetwork();

  const guardAction = <T,>(
    action: () => T,
    offlineMessage = 'This action requires an internet connection'
  ): T | null => {
    if (isOffline) {
      alert(offlineMessage);
      return null;
    }
    return action();
  };

  const guardAsyncAction = async <T,>(
    action: () => Promise<T>,
    offlineMessage = 'This action requires an internet connection'
  ): Promise<T | null> => {
    if (isOffline) {
      alert(offlineMessage);
      return null;
    }
    return action();
  };

  return {
    isNetworkOffline: isOffline,
    isOffline,
    pendingOperationsCount,
    guardAction,
    guardAsyncAction,
  };
};
